import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';

import { PlatformService } from 'app/core/services/platform.service';
import { AuthService } from 'app/core/services/auth.service';

@Component({
  standalone: false,
  selector: 'pptl-delivery-layout',
  templateUrl: 'delivery-layout.component.html',
  styleUrls: ['../layout-component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DeliveryLayoutComponent implements OnInit {
  public isLogined$: Observable<boolean>;

  constructor(
    private platformService: PlatformService,
    private authService: AuthService,
    private renderer: Renderer2,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.isLogined$ = this.authService.isLoggined();
    if (this.platformService.isAndroid()) {
      this.renderer.addClass(this.el.nativeElement, 'is-android');
    }
  }

  get isDevicePlatform(): boolean {
    return this.platformService.isCordova();
  }

  get isDesktop(): boolean {
    return this.platformService.isDesktop();
  }
}
